module.exports = __webpack_public_path__ + "img/Pista_1800_2.af148950.png";